import { render, staticRenderFns } from "./EmailIcon.vue?vue&type=template&id=10fd8198&scoped=true"
var script = {}
import style0 from "./EmailIcon.vue?vue&type=style&index=0&id=10fd8198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd8198",
  null
  
)

export default component.exports